// common service utilities
export default {

  // return only the data on success
  extractData(res, key = 'data') {
    if (res.status >= 200 && res.status < 300) {
      return Promise.resolve(res.body[key])
    }
  }
}
